<template>
    <div class="button-choice">
        <span v-if="label" class="button-choice__label">{{ label }}</span>
        <div class="button-choice__items">
            <button-element
                v-for="(choice, index) in getChoices"
                :key="`buttonchoice-index-${index}`"
                @click="() => handleChoiceClick(choice.id)"
                :type="value == choice.id ? 'secondary' : 'primary'"
                :button="{
                    'label': choice.title,
                }"
            ></button-element>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: 'ButtonChoiceElement',
    components: {

    },
    props: {
        label: String,
        name: {
            type: String,
            required: true
        },
        value: {
            type: String,
            default: false
        },
        choices: {
            type: Array,
            required: true
        },
        id: String
    },

    data: () => {
        return {
        }
    },
    computed: {
        getChoices() {
            return this.choices.filter((choice) => {
                return choice.id != -1;
            });
        },
    },
    created() {
    },
    mounted() {

    },
    methods: {
        handleChoiceClick(value) {
            this.value = value;
            this.$emit('input', value)
        }
    },
}
</script>
